import React from "react";
import PropTypes from "prop-types";
import { Grid, Container } from "@mui/material";
import Markdown from "markdown-to-jsx";
import "@fortawesome/fontawesome-free/css/all.css";
import styles from "./index.module.scss";

function Template({ data }) {
  const {
    title,
    image,
    text,
    text2,
    cta_label: ctaLabel,
    cta_link: ctaLink,
  } = data;

  return (
    <Container maxWidth="xl" className={styles.wrapper}>
      <Grid container>
        <Grid item sm={12} md={8} lg={8}>
          <h1 className={styles.title}>
            {" "}
            {title}
            {" "}
          </h1>
          <p className={styles.text}>
            {" "}
            {text}
            {" "}
          </p>
          <a className={styles.cta} href={ctaLink}>
            {ctaLabel}
          </a>
          <p className={styles.text2}>
            <Markdown>{text2}</Markdown>
          </p>
        </Grid>
        <Grid item sm={12} md={4} lg={4} className={styles.imageWrapper}>
          <img
            className={styles.image}
            src={image.src.publicURL}
            alt={image.alt}
          />
        </Grid>
      </Grid>
    </Container>
  );
}

Template.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    image: PropTypes.shape({
      src: PropTypes.shape({
        publicURL: PropTypes.string,
      }),
      alt: PropTypes.string,
    }),
    text: PropTypes.string,
    text2: PropTypes.string,
    cta_label: PropTypes.string,
    cta_link: PropTypes.string,
  }).isRequired,
};

export default Template;
